import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss']
})
export class ScrollTopComponent implements OnInit {
  windowScrolled: boolean = false;
  topOffset: number = 150; // Distância em pixels para exibir o botão

  constructor(@Inject(DOCUMENT) private document: Document) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Captura a posição atual do scroll de forma segura entre diferentes navegadores
    const scrollPosition = window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
    
    // Se a posição for maior que o offset (150px), vira true. Se não, vira false.
    this.windowScrolled = scrollPosition > this.topOffset;
  }

  scrollToTop() {
    // Solução nativa: o navegador faz o scroll suave e cancela sozinho se o usuário interagir
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  ngOnInit() {}
}